import styled from '@emotion/styled';
import { Link } from '~/shared/components/Link';
import { cover } from '~/shared/utils/styled';
import { breakpoints } from '~/theme';

export const StyledCategories = styled.div(({ theme }) => ({
    display: 'grid',
    gridTemplateColumns: 'repeat(2, 1fr)',
    gap: theme.space[1],

    [breakpoints.md]: {
        gridTemplateColumns: 'repeat(4, minmax(200px, 1fr))',
    },
}));

export const StyledCategory = styled.div(({ theme }) => ({
    position: 'relative',
    display: 'flex',
    backgroundColor: theme.colors.offWhite,
    flexDirection: 'column',
    alignItems: 'center',
    gap: theme.space[5],
    padding: `${theme.space[5]} ${theme.space[2]}`,

    [breakpoints.md]: {
        [`&:hover ${StyledAction}, &:active ${StyledAction}, &:focus ${StyledAction}`]: {
            svg: {
                transform: `translateX(${theme.space[2]})`,
            },
        },
    },
}));

export const StyledContent = styled.div(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: theme.space[2],
    textAlign: 'center',
}));

export const StyledAction = styled.div(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    fontSize: theme.fontSizes.beetle,
    svg: {
        height: '20px',
        width: '20px',
        paddingLeft: theme.space[1],
        transition: `transform 250ms ${theme.easings.smoothEase}`,
    },
}));

export const StyledLink = styled(Link)(({ theme }) => ({
    fontSize: theme.fontSizes.beetle,
    ...cover,
}));
